module.exports = "data:image/png;base64,UklGRj4BAABXRUJQVlA4IDIBAACQCACdASoqACsAPmkskEWkIqGarAQAQAaEtIAK4A7AKzA1AUvbxv6gH6q/7vgOf1uPRYcrP6jqHH28RNE/Yy2Id5RZHAsi1s9zxs2cAAD+8LBwd54ZKxSBQ1ENQ+F9pkrOi4UsGJF9OJ2wwoXJRWn/Fnfyjds2eS/S4TESFnBP3yN9vTB8w5faJxZm1fSzSPojeu/kGRXpSg4GfkLDWR7PXeyrNwTSLxfmJh/O+QyVq3FTpsWbs8UJzJFFe/Bf2ZXdc86PN/Pw1ZS1PEcqBu5TSnm8pPl/CYd5iDWwQ2JyxX3fU2lpc0CcDxtAhW0VdcsD0IvBuFEEmJPvdU+2Qi+ATakg5ZlQn7ihmu2je7ka8G4yW1rE7iY4cyr8k2J1Gs+inOo365beIs2t+9L5/7PgAAA="


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/Information/news60/news60_19.png
// module id = UGLd
// module chunks = 0